import Devise from "@kaspernj/api-maker/build/devise"
import {Role} from "models"
import TranslatedCollections from "@kaspernj/api-maker/build/translated-collections"

const isUserA = function isUserA(user, roleIdentifiers) {
  if (typeof roleIdentifiers == "string") {
    roleIdentifiers = [roleIdentifiers]
  }

  if (!user) return false
  if (!Array.isArray(roleIdentifiers)) throw new Error(`roleIdentifier wasn't a string or an array: ${typeof roleIdentifier}`)

  const translatedRoles = TranslatedCollections.get(Role, "identifier").map(({value}) => value)

  for (const roleIdentifier of roleIdentifiers) {
    if (roleIdentifier == "school_leader" || roleIdentifier == "teacher") {
      return user.identifiedRoles().includes(roleIdentifier)
    } else {
      if (!translatedRoles.includes(roleIdentifier)) throw new Error(`Unknown role identifier: ${roleIdentifier}`)

      for (const userRole of user.userRoles().loaded()) {
        if (userRole.role().identifier() == roleIdentifier) {
          return true
        }
      }
    }
  }

  return false
}

const isUserOnSchoolA = function isUserOnSchoolA(user, {identifiers}) {
  if (user) {
    const parentRelationships = user.contact()?.parentRelationships()?.loaded()

    if (parentRelationships) {
      for (const parentRelationship of parentRelationships) {
        const relationshipType = parentRelationship.contactRelationshipType().identifier()

        if (identifiers.includes(relationshipType)) {
          return true
        }
      }
    }
  }

  return false
}

const isCurrentUserA = (roleIdentifier) => Devise.isUserSignedIn() && isUserA(Devise.currentUser(), roleIdentifier)

export {isCurrentUserA, isUserOnSchoolA}
export default isUserA
